import React from "react";
import { useTranslation } from "react-i18next";
import Flap from "./Flap";
import {
  faBook,
  faQuestionCircle,
  faUser,
} from "@fortawesome/pro-solid-svg-icons";
import Message from "../../../global/notification/Message";
import {
  TextVariant,
  TypographyNew,
} from "../../../global/typography/typography";
import EmployeeAvatarNew from "../../../global/avatars/EmployeeAvatarNew";
import { NotificationContainer } from "../pages/overview/styles";
import styled, { useTheme } from "styled-components";
import { AnchorLink, AStyled } from "../../../global/buttonsLinks/LinkStyled";
import useIntercom from "./intercom";
import ShortcutsLink from "./Shortcuts/ShortcutsLink";
import Authorized from "../../../global/common/Authorized";
import { Role } from "../../../redux/api-model/organization/company";

const EmployeeAvatarContainer = styled.div`
  display: flex;
  align-items: center;
`;

const CustomerServiceLinks = styled.div`
  min-width: 50px;
`;

const HelpFlap: React.FC = () => {
  const { t } = useTranslation("top-bar");
  const theme = useTheme();

  useIntercom();

  return (
    <Flap icon={faQuestionCircle}>
      <NotificationContainer>
        <Message
          icon={faBook}
          component1={
            <>
              <TypographyNew variant={TextVariant.subtitle2}>
                {t("topbar.knowledgeBase")}
              </TypographyNew>
              <TypographyNew
                variant={TextVariant.body1}
                marginTop={"10px"}
                color={theme.colors.grays2}
              >
                Lernen Sie HeavenHR 2.0 kennen mit
                <br /> detaillierten Erklärungen und
                <br /> vielen Beispielen.{" "}
              </TypographyNew>
            </>
          }
          component2={
            <TypographyNew variant={TextVariant.subtitle2}>
              <AStyled
                target={"_blank"}
                href={"https://intercom.help/heavenhr2/en/"}
              >
                {t("topbar.goToDocumentation")}
              </AStyled>
              <ShortcutsLink />
            </TypographyNew>
          }
        />
      </NotificationContainer>
      <NotificationContainer>
        <Message
          icon={faUser}
          component1={
            <>
              <TypographyNew
                variant={TextVariant.subtitle2}
                marginBottom={"20px"}
              >
                {t("topbar.customerServiceAgent")}
              </TypographyNew>
              <EmployeeAvatarContainer>
                <EmployeeAvatarNew
                  size={"SMALL"}
                  imgUrl={
                    "https://st.focusedcollection.com/3839757/i/1800/focused_178411440-stock-photo-male-office-worker-working-laptop.jpg"
                  }
                />
                <div>
                  <TypographyNew
                    variant={TextVariant.body1}
                    marginLeft={"10px"}
                  >
                    Alexandra Gunia
                  </TypographyNew>
                  <TypographyNew
                    variant={TextVariant.body2}
                    color={theme.colors.grays2}
                    marginLeft={"10px"}
                  >
                    Senior Customer Service
                  </TypographyNew>
                </div>
              </EmployeeAvatarContainer>
              <TypographyNew
                variant={TextVariant.body1}
                color={theme.colors.grays2}
                marginTop={"10px"}
              >
                {t("help.description")}
              </TypographyNew>
            </>
          }
          component2={
            <CustomerServiceLinks>
              <Authorized
                visibleFor={[Role.COMPANY_ACCESS, Role.DEPARTMENT_ACCESS]}
              >
                <TypographyNew variant={TextVariant.subtitle2}>
                  <AnchorLink id="chat_launcher">{t("topbar.chat")}</AnchorLink>
                </TypographyNew>
              </Authorized>
              <TypographyNew variant={TextVariant.subtitle2} marginTop={"20px"}>
                <AnchorLink href="mailto:info@heavenhr.de">
                  {t("topbar.email")}
                </AnchorLink>
              </TypographyNew>
              <TypographyNew variant={TextVariant.subtitle2} marginTop={"20px"}>
                <AnchorLink href="tel:030555743990">
                  {t("topbar.call")}
                </AnchorLink>
              </TypographyNew>
            </CustomerServiceLinks>
          }
        />
      </NotificationContainer>
    </Flap>
  );
};

export default HelpFlap;
